import * as _ from 'lodash';
import * as Normalize from '../normalize';
import * as PanelNormalize from '../panel/normalize';
import * as Types from './types';
import {LayedOutPanel} from '../../../util/panels';

export const normalize = Normalize.normFn<Types.PanelsObjSchema>(
  'panels',
  (whole, ctx) => {
    const viewKeys = _.keys(whole.views);
    const key = viewKeys[0];
    if (key == null) {
      // item.views used to be used to store different sets of panels for tabs.
      // This is no longer the case, and the panels structure always contains a
      // single key.
      throw new Error('invalid state');
    }
    return {
      ...whole,
      views: {
        [key]: {
          ...whole.views[key],
          panelRefs: whole.views[key].config.map(p =>
            PanelNormalize.normalize(p, ctx)
          ),
          config: undefined,
        },
      },
    };
  }
);

export const denormalize = Normalize.denormFn<Types.PanelsObjSchema>(
  (part, ctx) => {
    const viewKeys = _.keys(part.views);
    const key = viewKeys[0];
    if (key == null) {
      // item.views used to be used to store different sets of panels for tabs.
      // This is no longer the case, and the panels structure always contains a
      // single key.
      throw new Error('invalid state');
    }
    return {
      ...part,
      views: {
        [key]: {
          ...part.views[key],
          config: part.views[key].panelRefs.map(
            r => PanelNormalize.denormalize(r, ctx) as LayedOutPanel
          ),
        },
      },
    };
  }
);
